import api from "../utils/api";

// Note: The API base URL is configured in utils/api.js to use port 9000

// Common Comments API Service
export const commentService = {
  // Get all comments for any commentable resource (blog, product, etc.)
  // Use central api instance; for public read, ensure no auth header is sent if not present
  getComments: async (commentableType, commentableId) => {
    try {
      const response = await api.get(`/api/v1/${commentableType.toLowerCase()}s/${commentableId}/comments`, {
        // Explicitly avoid sending auth header if no token; interceptor already handles missing token
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching comments:", error);
      throw error;
    }
  },

  // Create a new comment
  createComment: async (commentableType, commentableId, commentData) => {
    try {
      const response = await api.post(`/api/v1/${commentableType.toLowerCase()}s/${commentableId}/comments`, {
        comment: commentData,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating comment:", error);
      throw error;
    }
  },

  // Update an existing comment
  updateComment: async (commentableType, commentableId, commentId, commentData) => {
    try {
      const response = await api.put(`/api/v1/${commentableType.toLowerCase()}s/${commentableId}/comments/${commentId}`, {
        comment: commentData,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating comment:", error);
      throw error;
    }
  },

  // Delete a comment
  deleteComment: async (commentableType, commentableId, commentId) => {
    try {
      const response = await api.delete(
        `/api/v1/${commentableType.toLowerCase()}s/${commentableId}/comments/${commentId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting comment:", error);
      throw error;
    }
  },

  // Get a specific comment
  getComment: async (commentableType, commentableId, commentId) => {
    try {
      const response = await api.get(`/api/v1/${commentableType.toLowerCase()}s/${commentableId}/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching comment:", error);
      throw error;
    }
  },
};

export default commentService;
